import React from "react";
import { Group, Stack, Divider, Button, Text } from "@mantine/core";
import { ReactComponent as DeleteIcon } from "./DeleteIcon.svg";

interface DeleteConfirmationProps {
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string
    message?: string; // New optional prop for a custom confirmation message
    title?: string; // New optional prop for a custom title
    isLoading?: boolean; // Optional prop to indicate loading state
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
    onConfirm,
    onCancel,
    confirmText,
    message,
    title,
    isLoading,
}) => {
    return (
        <div className="delete-confirmation-overlay">
            <div className="delete-confirmation-box">
                <Group spacing="sm" className="delete-confirmation-header">
                    <div className="delete-confirmation-icon-box">
                        <DeleteIcon />
                    </div>
                    <Stack pb="10px">
                        <Text className="delete-confirmation-title">{title || "Confirm"}</Text>
                        <Text className="delete-confirmation-message">
                            {message || "Are you sure you want to delete?"}
                        </Text>
                    </Stack>
                </Group>

                <Divider color="#C3C0C0" mt="md" pt="10px" />

                <Group position="right" mt="md">
                    <Button
                        variant="filled"
                        color="dark"
                        className="delete-button"
                        onClick={onConfirm}
                        loading={isLoading ?? false}
                    >
                        {confirmText || "Delete"}
                    </Button>
                    <Button
                        variant="outline"
                        color="gray"
                        className="cancel-button"
                        onClick={onCancel}
                        loading={isLoading ?? false}
                    >
                        Cancel
                    </Button>
                </Group>
            </div>
        </div>
    );
};

export default DeleteConfirmation;
